import Input from "./Input";
import Label from "../../components/Label";
import TextFilter from "../../components/TextFilter";
import { P2 } from "../../components/Paragraph";
import classNames from "classnames";
import styles from "./listSelector.module.css";

const ListSelector = ({
  listAttributes,
  filteredOptions,
  filterAttribs,
  grow,
  disabled,
  ...rest
}) => {
  if (!Array.isArray(listAttributes?.options)) return null;

  const ListOption = ({ option, value }) => {
    let content = (
      <Input
        type="checkbox"
        label={option.label}
        value={value}
        disabled={disabled || option.disabled}
        onClick={() => {
          listAttributes.onChange(option);
        }}
      />
    );
    if (option.details != null) {
      content = (
        <>
          <Input
            type="checkbox"
            label={option.label}
            value={value}
            onClick={() => {
              listAttributes.onChange(option);
            }}
            disabled={disabled || option.disabled}
          />
          <P2
            style={{
              paddingLeft:
                "calc(var(--text-base-height) + var(--gap-form-item))",
            }}
          >
            {option.details}
          </P2>
        </>
      );
    }
    if (option.tag) {
      return (
        <span
          className={classNames(
            styles.listSelectorWrapper,
            styles[option.tag.toLowerCase()]
          )}
        >
          {content}
        </span>
      );
    }
    return content;
  };

  let content;
  if (listAttributes.options.length < 11) {
    content = (
      <div
        className={classNames(styles.selectionList, styles.options, {
          [styles.grow]: grow,
        })}
      >
        {listAttributes?.options?.map((option) => {
          const valueIdx = listAttributes?.value?.findIndex(
            (value) => value.id === option.id
          );
          return (
            <ListOption key={option.id} option={option} value={valueIdx > -1} />
          );
        })}
      </div>
    );
  } else {
    content = (
      <div
        {...rest}
        className={classNames(styles.selectionList, styles.options, {
          [styles.grow]: grow,
        })}
      >
        <span>
          {Array.isArray(listAttributes?.value) &&
            listAttributes?.value.length > 0 && (
              <span>
                {listAttributes?.value.map((option) => (
                  <ListOption key={option.id} option={option} value={true} />
                ))}
              </span>
            )}
        </span>
        <span>
          {!disabled &&
          Array.isArray(listAttributes?.options) &&
          Array.isArray(listAttributes?.value) &&
          listAttributes?.options.length - listAttributes?.value.length > 0 ? (
            <TextFilter {...filterAttribs} unpadded />
          ) : (
            <div />
          )}
        </span>
        <span>
          {Array.isArray(filteredOptions) && filteredOptions.length > 0 && (
            <div
              className={classNames(styles.selectionList, styles.options, {
                [styles.grow]: grow,
              })}
            >
              {filteredOptions?.map((option) => (
                <ListOption key={option.id} option={option} value={false} />
              ))}
            </div>
          )}
        </span>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexGrow: "1",
        gap: "var(--gap-form-item)",
        overflow: "hidden",
      }}
    >
      {listAttributes?.label && <Label>{listAttributes?.label}</Label>}
      {content}
    </div>
  );
};

export default ListSelector;
